import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "../../styles/breakpoints";
import { glass } from "../../styles/globals.css";
import { vars } from "../../styles/theme.css";

const sharedCardStyles = style({
  width: 67,
  height: 92,

  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: {
      width: 112,
      height: 140,
    },
  },
});

export const elementCardStyles = style([
  glass.card,
  sharedCardStyles,
  {
    transitionDuration: "0.2s",
    transitionProperty: "all",
    border: `1px solid color-mix(in srgb, ${vars.colors.white} 20%, transparent)`,
    borderRadius: vars.radii.xs,
    color: vars.colors.white,

    selectors: {
      "&[data-hovered]": {
        backgroundColor: `color-mix(in srgb, ${vars.colors.white} 10%, ${vars.colors.glass})`,
      },
      "&[data-pressed]": {
        outline: "none",
        backgroundColor: `color-mix(in srgb, ${vars.colors.white} 25%, ${vars.colors.glass})`,
      },
      "&[data-focused]": {
        outline: "none",
      },
      "&[data-focus-visible]": {
        outline: "auto",
      },
    },
  },
]);

export const pitchElementWrap = style([
  sharedCardStyles,
  {
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
]);

export const pitchElement = style({
  display: "flex",
  flexDirection: "column",
  height: "100%",
});

export const elementCost = style({
  display: "block",
  lineHeight: 1.4,
  color: vars.colors.white,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      padding: "5px 0",
      lineHeight: 1,
      fontSize: vars.fontSizes.body.l,
    },
  },
});
const pitchElementDataBase = style({
  position: "absolute",
  bottom: "0.1rem",
  insetInlineStart: "0.1rem",
  insetInlineEnd: "0.1rem",
  display: "flex",
  flexDirection: "column",
  borderRadius: 3,
  backgroundColor: vars.colors.onPrimary,
  color: vars.colors.primary,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      fontSize: vars.fontSizes.body.s,
    },
  },
});

export const pitchElementData = styleVariants({
  default: [pitchElementDataBase],
  removed: [pitchElementDataBase, { opacity: "40%" }],
});

// Element Card Icon positioning

const iconPositionBase = style({
  position: "absolute",
});

const topIcon = style({
  top: vars.space["2xs"],

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      top: vars.space.xs,
    },
  },
});

export const topLeftIconList = style([
  iconPositionBase,
  topIcon,
  {
    insetInlineStart: vars.space["2xs"],
    // Needs display flex to align Pick Team Switch, Captain and Dream Team icons vertically
    display: "flex",
    flexDirection: "column",
    gap: vars.space["2xs"],

    "@media": {
      [`(min-width: ${breakpoints[2]})`]: {
        insetInlineStart: vars.space.xs,
      },
    },
  },
]);

const pitchIconBase = style({
  // Flex display ensures child buttons/icons are properly contained.
  // Without it, inline children with vertical-align sit too low because
  // vertical-align aligns to the line box baseline, not the container.
  display: "flex",
  width: 10,
  height: 10,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      width: 16,
      height: 16,
    },
  },
});

export const topRightIcon = style([
  iconPositionBase,
  topIcon,
  pitchIconBase,
  {
    insetInlineEnd: vars.space["2xs"],

    "@media": {
      [`(min-width: ${breakpoints[2]})`]: {
        insetInlineEnd: vars.space.xs,
      },
    },
  },
]);

export const bottomRightIcon = style([
  iconPositionBase,
  pitchIconBase,
  {
    bottom: 34,
    insetInlineEnd: vars.space["2xs"],

    "@media": {
      [`(min-width: ${breakpoints[2]})`]: {
        bottom: 48,
        insetInlineEnd: vars.space.xs,
      },
    },
  },
]);
